@if (items(); as items) {
  <a [routerLink]="items.length > 1 ? items[items.length - 2].routerLink : '/'"
     [queryParams]="items.length > 1 ? items[items.length - 2].queryParams : {}"
     class="mobile-back d-inline-flex d-lg-none flex-row align-items-center">

    <mat-icon class="icon" svgIcon="sax:outline-arrow-left-2"></mat-icon>

    <span class="label">

      @if (items.length > 1) {
        {{ items[items.length - 2].mobileLabel || items[items.length - 2].label }}
      } @else {
        <ng-container i18n>Головна</ng-container>
      }

    </span>

  </a>

  <div class="breadcrumbs-list d-none d-lg-flex flex-row align-items-center" itemscope
       itemtype="http://schema.org/BreadcrumbList">

    <div class="breadcrumb-item root d-inline-flex" itemprop="itemListElement" itemscope
         itemtype="http://schema.org/ListItem">

      <a routerLink="/" class="d-inline-flex" itemprop="item" title="Головна" i18n-title>
        <mat-icon svgIcon="sax:outline-home-2" class="root-icon"></mat-icon>
        <meta itemprop="name" content="Головна" i18n-content />
        <meta itemprop="position" content="0">
      </a>

    </div>

    @for (item of items; track item.label; let index = $index; let isLast = $last) {

      <mat-icon svgIcon="sax:outline-arrow-right-3" class="delimiter d-inline-flex"></mat-icon>

      @if (isLast) {

        <div class="breadcrumb-item current d-inline-flex">

          <span>{{ item.label }}</span>

        </div>

      } @else {

        <div class="breadcrumb-item d-inline-flex" itemprop="itemListElement" itemscope
             itemtype="http://schema.org/ListItem">

          <a [routerLink]="item.routerLink" [queryParams]="item.queryParams" class="d-inline-flex" itemprop="item">
            {{ item.label }}
            <meta [content]="item.label" itemprop="name" />
            <meta [content]="index + 1" itemprop="position">
          </a>

        </div>

      }

    }

  </div>

}
